module.exports = __webpack_public_path__ + "a9b2c424d81b5b6aed2d1a19287ab74d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/sidebar-search-close.png
 ** module id = 386
 ** module chunks = 0
 **/